import React, { useEffect, useState } from "react";
import Toolbar, { Item } from "devextreme-react/toolbar";
import Button from "devextreme-react/button";
import UserPanel from "../user-panel/UserPanel";
import "./Header.scss";
import { Template } from "devextreme-react/core/template";
import CustomDrawer from "../customDrawer/CustomDrawer";
import NotificationMain from "../notificationDrawer/notification-main";
import { useAuth } from "../../contexts/auth";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "devextreme-react";
import {
  getCustomerByCodeApi,
  getCustomerContactProfileData,
} from "../../api/companyCustomerApi";

export default function Header({ menuToggleEnabled, title, toggleMenu }) {
  const { user, unreadCount } = useAuth();
  const navigate = useNavigate();

  const [opened, setOpened] = useState(false);
  const [projects, setProjects] = useState([]);

  // useEffect(() => {
  //   const fetchProjects = async () => {
  //     try {
  //       const res = await getCustomerByCodeApi(user?.custcode);

  //       const assigned = res?.data?.data?.assigned_projects || [];

  //       // flatten subcategories into simple list
  //       const projectList = assigned.flatMap((cat) =>
  //         cat.subcategories.map((sub) => ({
  //           name: sub.ticketsubcatname,
  //           access_deadline: sub.access_deadline,
  //         })),
  //       );

  //       setProjects(projectList);
  //     } catch (err) {
  //       console.error("Error fetching projects", err);
  //     }
  //   };

  //   if (user?.custcode) fetchProjects();
  // }, [user]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        let res;

        if (user?.userrole === "customer") {
          res = await getCustomerByCodeApi(user?.custcode);
        } else if (user?.userrole === "customercontact") {
          res = await getCustomerContactProfileData(user?.contactcode);
        }

        const assigned = res?.data?.data?.assigned_projects || [];

        const projectList = assigned.flatMap((cat) =>
          cat.subcategories.map((sub) => ({
            name: sub.ticketsubcatname,
            access_deadline: sub.access_deadline,
          })),
        );

        setProjects(projectList);
      } catch (err) {
        console.error("Error fetching projects", err);
      }
    };

    if (user?.custcode || user?.contactcode) {
      fetchProjects();
    }
  }, [user]);

  const openNotification = () => {
    setOpened(true);
  };

  // console.log("USER:", user);
  const isClientUser =
    user?.userrole === "customer" || user?.userrole === "customercontact";

  //Function to capitalize the First Letter of the Logged In User:
  const capitalizeFirst = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getExpiryMessage = (deadline) => {
    if (!deadline) return null;

    const now = new Date();
    const expiry = new Date(deadline);

    const diffTime = expiry - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) {
      return "has expired. Please contact QIT Support to renew";
    }

    if (diffDays <= 15) {
      return `will expire in ${diffDays} day${diffDays > 1 ? "s" : ""}.`;
    }

    return null;
  };
  const expiringProjects = projects
    .map((p) => {
      const message = getExpiryMessage(p.access_deadline);
      return message ? { ...p, message } : null;
    })
    .filter(Boolean);

  // sort by nearest expiry
  const sortedProjects = expiringProjects.sort(
    (a, b) => new Date(a.access_deadline) - new Date(b.access_deadline),
  );

  const nearestProject = sortedProjects[0];
  const extraCount = sortedProjects.length - 1;

  const message = nearestProject
    ? getExpiryMessage(nearestProject.access_deadline)
    : null;

  return (
    <>
      <div className="flex-container">
        <CustomDrawer
          visible={opened}
          Component={(props) => (
            <NotificationMain
              {...props}
              visible={opened}
              closeHandler={() => setOpened(false)}
            />
          )}
        />
      </div>

      {isClientUser && nearestProject && (
        <Tooltip
          target=".expiry-tooltip-target"
          showEvent="mouseenter" // ✅ consistent pair
          hideEvent="mouseleave"
          position="bottom"
        >
          <div className="expiry-tooltip-content">
            {sortedProjects.map((p, i) => (
              <div key={i}>
                <strong>{p.name}</strong>: {p.message}
              </div>
            ))}
          </div>
        </Tooltip>
      )}

      <header className={"header-component"}>
        <Toolbar className={"header-toolbar"}>
          <Item
            visible={menuToggleEnabled}
            location={"before"}
            widget={"dxButton"}
            cssClass={"menu-button"}
          >
            <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
          </Item>
          <Item location={"before"}>
            <div className="header-username">
              <span>
                Welcome ,{" "}
                {/* {user?.username || user?.email?.split("@")[0] || "Username"} */}
                {user?.login_name ? capitalizeFirst(user.login_name) : "Back!"}
              </span>
            </div>
          </Item>

          <Item
            location={"before"}
            cssClass={"header-title"}
            text={title}
            visible={!!title}
          />

          {/* <Item cssClass={"header-title"} text={title} location="after">
            <i className="ri-add-circle-fill plus-icon"></i>
          </Item> */}

          {isClientUser && nearestProject && (
            <Item location="after" cssClass="expiry-banner-item">
              <div
                className="expiry-banner expiry-tooltip-target"
                onClick={() => {
                  if (user?.userrole === "customer") {
                    navigate("/CustomerProfile", {
                      state: { section: "projects" },
                    });
                  } else if (user?.userrole === "customercontact") {
                    navigate("/CustomerContactProfile", {
                      state: { section: "projects" },
                    });
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                <i className="ri-error-warning-line expiry-icon"></i>

                <span className="expiry-text">
                  <strong>{nearestProject.name}</strong>{" "}
                  {nearestProject.message}
                  {extraCount > 0 && ` (+${extraCount} more)`}
                </span>
              </div>
            </Item>
          )}

          {/* Help Center Icon */}
          <Item
            location="after"
            cssClass="header-help-icon"
            onClick={() => navigate("/help-center")}
          >
            <i className="ri-customer-service-2-line"></i>
          </Item>

          <Item
            cssClass={"header-title"}
            text={title}
            location="after"
            height={"40px !important"}
            // onClick={() => setOpened(true)}
            onClick={openNotification}
          >
            <div className="bell-container">
              <i className="ri-notification-4-line header-bell-icon"></i>

              {unreadCount > 0 && (
                <span className="notification-badge">
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </div>
            {/* <i className="ri-notification-4-line header-bell-icon"></i> */}
          </Item>
          <Item
            location={"after"}
            locateInMenu={"auto"}
            menuItemTemplate={"userPanelTemplate"}
          >
            <Button
              className={"user-button authorization"}
              width={210}
              height={"100%"}
              stylingMode={"text"}
            >
              <UserPanel menuMode={"context"} />
            </Button>
          </Item>
          <Template name={"userPanelTemplate"}>
            <UserPanel menuMode={"list"} />
          </Template>
        </Toolbar>
      </header>
    </>
  );
}
